import React from 'react';
import LocalizedStrings from 'react-localization';
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import NavigationWrapper from './Containers/NavigationWrapper/NavigationWrapper'
import { localisedText } from '../../../lib/localisation.es6';
import { getCustomer } from '../../../containers/Customer/actions.es6';
import PolicyHeader from './Containers/PolicyHeader/PolicyHeader';
import BboxxEditUser from './Containers/EditUser/index'
class BboxxKenyaCustomerStatus extends React.Component {

	constructor(props) {
		const localizedStrings = new LocalizedStrings(localisedText);
		super(props);
		this.state = {
			labels: localizedStrings,
			openEditCustomerDialog: false,

		};
	}

	componentWillMount() {
		this.updateLanguage();
		let customer_guid = this.props.params.customer_guid
		if (customer_guid) {
			this.setState({ customer_guid: customer_guid })
			this.refreshCustomerStatus(customer_guid);
		}

	}

	componentDidUpdate() {
		this.updateLanguage();
	}

	updateLanguage() {
		const language = this.props.globalData.language;
		let resetLanguage = false;
		if (!language) {
			resetLanguage = true;
		}
		const labels = this.state.labels;
		if (resetLanguage || labels.getLanguage() !== language) {
			labels.setLanguage(language);
			this.setState({});
		}
	}


	refreshCustomerStatus(customer_guid) {
		this.props.dispatch(getCustomer(customer_guid));

	}

	toggleEditCustomerDialog() {
		this.setState({ openEditCustomerDialog: !this.state.openEditCustomerDialog })
	}


	render() {

		if (this.props.customerData.currentCustomer) {
			return (
				<>
					<PolicyHeader />
					<BboxxEditUser
						openEditCustomerDialog={this.state.openEditCustomerDialog}
						toggleEditCustomerDialog={this.toggleEditCustomerDialog.bind(this)}
					/>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={12} md={12}>
							<section style={{
								background: "#FFFFFF",
								borderRadius: "8px",
								height: "auto",
								marginTop: "30px",
								padding: "30px"
							}}>

								<NavigationWrapper
									labels={this.state.labels}
									loading={this.props.customerData.loader}
									customerData={this.props.customerData.currentCustomer}

									toggleEditCustomerDialog={this.toggleEditCustomerDialog.bind(this)}
									customer_guid={this.props.customerData.currentCustomer.guid}
								/>

							</section>
						</Grid>

					</Grid>

				</>
			)
		} else {
			return ""
		}

	}
}
export default connect((state) => ({
	customerData: state.currentCustomer,
	QuoteData: state.quoteData,
	globalData: state.global,
	profileData: state.profile,
}))(BboxxKenyaCustomerStatus);